import React from "react";

import { Stack, StackProps } from "./Stack";

export const HStack = React.forwardRef<
  React.ElementRef<typeof Stack>,
  StackProps
>(function HStack(props, ref) {
  return <Stack ref={ref} flexDirection={"row"} {...props} />;
});
